import React from "react";
import "./Home.css";
import { Schedule } from "../Schedule";

export const SchedulePage = () => {
  return (
    <div className="form-page-layout">
      <h2 className="title">Conference Schdule</h2>

      <div className="form-layout">
        <Schedule />
      </div>
    </div>
  );
};
